import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import api from '../services/api';
import { getCountryFlag } from '../utils/countries';
import ProfileInventoryAchievements from '../components/ProfileInventoryAchievements';
import './Profile.css';
import './Betting.css';

const Profile = () => {
  const { username: usernameParam } = useParams();
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  // useParams is already decoded; avoid decodeURIComponent (can throw on stray %)
  const username = (usernameParam || '').trim();

  useEffect(() => {
    if (!username) {
      setLoading(false);
      setError('Invalid profile');
      return;
    }
    let cancelled = false;
    (async () => {
      setLoading(true);
      setError('');
      try {
        const res = await api.get(`/players/${encodeURIComponent(username)}`);
        if (!cancelled) setProfile(res.data);
      } catch (err) {
        if (cancelled) return;
        if (err.response?.status === 404) {
          setError('Player not found');
          setProfile(null);
        } else {
          setError('Could not load profile');
          setProfile(null);
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [username]);

  return (
    <div className="betting-page profile-page">
      <header className="betting-header">
        <p className="profile-back">
          <Link to="/standings" className="profile-back-link">
            ← Standings
          </Link>
          <span className="profile-back-sep"> · </span>
          <Link to="/leagues" className="profile-back-link">
            Leagues
          </Link>
        </p>
        <h1 className="betting-title">Player profile</h1>
        <p className="betting-subtitle">Plays and league achievements</p>
      </header>

      {loading && <div className="sc-loading">Loading…</div>}
      {!loading && error && <div className="sc-error">{error}</div>}

      {!loading && profile && (
        <>
          <div className="sc-card profile-hero">
            <div className="profile-hero-name">
              <span className="profile-username">{profile.username}</span>
              {profile.country ? (
                <span className="profile-flag" title={profile.country}>
                  {getCountryFlag(profile.country)}
                </span>
              ) : null}
            </div>
            <p className="profile-prize-coins">
              Prize coins earned: <strong>{Number(profile.prizeCoins) || 0}</strong>
            </p>
          </div>

          <ProfileInventoryAchievements inventory={profile.inventory} achievements={profile.achievements} />
        </>
      )}
    </div>
  );
};

export default Profile;
